import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Button from '@material-ui/core/Button';

import PostOrder from '../../ListItems/PostOrder';
import PostOrderDialog from '../../Dialogs/AddPostOrder';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';


const PostOrders = ({ isEditable, timezone }) => {
  const [showPostOrderDialog, setShowPostOrderDialog] = useState(false);

  const postOrders = useSelector(state => state.postOrders.postOrders);
  
  const handleCreate = () => setShowPostOrderDialog(true);
  const handleClose = () => setShowPostOrderDialog(false);

  return (
    <>
      <List>
        {
          postOrders.map(
            (postOrder, index) => <PostOrder 
              key={index}
              postOrder={postOrder} 
              isEditable={isEditable}
              timezone={timezone} 
              index={index}
            />
          )
        }
        <ListItem>
          <Button
            color={'primary'}
            onClick={handleCreate}
          >
            Create post order
          </Button>
        </ListItem>
      </List>
      <PostOrderDialog 
        isOpen={showPostOrderDialog} 
        onClose={handleClose} 
        timezone={timezone}
      />
    </>
  )
};

export default PostOrders;